// components/common/GenderToggleSelector.js
import React from 'react';

export const GenderToggleSelector = ({ 
  value, 
  onChange, 
  error, 
  t 
}) => {
  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {t.gender}
      </label>
      <div className="flex bg-gray-100 rounded-lg p-1">
        <button
          type="button"
          onClick={() => onChange('female')}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            value === 'female'
              ? 'bg-white text-purple-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          {t.female}
        </button>
        <button
          type="button"
          onClick={() => onChange('male')}
          className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
            value === 'male'
              ? 'bg-white text-purple-600 shadow-sm'
              : 'text-gray-600 hover:text-gray-800'
          }`}
        >
          {t.male}
        </button>
      </div>
      {error && (
        <p className="text-red-500 text-sm mt-1 text-right">{error}</p>
      )}
    </div>
  );
};